import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ChevronDown, Link2, Lock, Menu, X, Globe } from "lucide-react";
import logo from '../assets/images/ksu-logo.png';
import saudiFlag from '../assets/images/saudi-flag.svg';
import dgi from '../assets/images/dgi.svg';

export default function Navbar() {
    const { t, i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [isVerifyOpen, setIsVerifyOpen] = useState(false);

    const toggleLanguage = () => {
        const newLang = i18n.language === 'ar' ? 'en' : 'ar';
        i18n.changeLanguage(newLang);
    };

    // Kood Al-Manasat Colors
    const colors = {
        primaryGreen: "#006C35",
        secondaryGold: "#EBB713",
        textMain: "#1F2937", // Slate-800
        textMuted: "#6B7280", // Slate-500
    };

    const links = [
        { name: t('navbar.home'), to: "/" },
        { name: t('navbar.about'), to: "/about" },
        { name: t('navbar.guides'), to: "/guides" },
        { name: t('navbar.contact'), to: "/contact" },
    ];

    return (
        <nav className="bg-white border-b border-gray-100 w-full fixed top-0 z-50 shadow-sm">
            {/* Saudi Unified Government Banner (Top Bar) */}
            <div className="w-full bg-slate-50 border-b border-slate-200">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between gap-3 py-2">
                        <div className="flex items-center gap-3 min-w-0">
                            <span className="inline-flex items-center justify-center w-7 rounded-sm overflow-hidden border border-slate-200 bg-white shrink-0" aria-hidden="true">
                                {/* Saudi flag (simplified) */}
                                <img src={saudiFlag} alt={t('navbar.saudiFlagAlt')} className="h-full w-full object-contain" />
                            </span>

                            <div className="min-w-0 text-right leading-tight">
                                <div className="text-[11px] text-slate-500 flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2">
                                    <span className="min-w-0 sm:truncate">
                                        {t('navbar.govBanner')}
                                    </span>
                                    <button
                                        type="button"
                                        onClick={() => setIsVerifyOpen(v => !v)}
                                        className="inline-flex items-center gap-1 whitespace-nowrap self-start sm:self-auto text-[11px] sm:text-[12px] font-semibold text-[#006C35] hover:text-[#005A2C] underline underline-offset-4"
                                        aria-expanded={isVerifyOpen}
                                        aria-controls="gov-verify-panel"
                                    >
                                        <span>{t('navbar.howToVerify')}</span>
                                        <ChevronDown size={16} className={`transition-transform ${isVerifyOpen ? "rotate-180" : ""}`} />
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* <div className="flex items-center gap-2 shrink-0">
                            <span className="inline-flex items-center rounded-full border border-slate-200 bg-white px-2.5 py-1 text-[11px] font-semibold text-slate-700">
                                نسخة تجريبية
                            </span>
                        </div> */}
                    </div>
                </div>
            </div>

            {/* Verify Dropdown Panel (like ksu.edu.sa) */}
            <div
                id="gov-verify-panel"
                className={`w-full border-b border-slate-200 bg-slate-50 overflow-hidden transition-all duration-300 ease-in-out ${isVerifyOpen ? "max-h-[420px] sm:max-h-[320px] md:max-h-[220px] opacity-100" : "max-h-0 opacity-0"
                    }`}
            >
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 ">
                        <div className="flex items-start sm:items-center gap-2 sm:gap-3">
                            <span className="inline-flex h-8 w-8 sm:h-9 sm:w-9 items-center justify-center rounded-full bg-white border-[2px] border-[#006C35] text-[#006C35] shrink-0">
                                <Lock size={18} />
                            </span>
                            <div className="min-w-0 text-right leading-snug">
                                <div className="text-[12px] font-bold text-[#006C35] whitespace-normal break-words md:truncate md:whitespace-nowrap">
                                    {t('navbar.eduLinksTitle')}
                                </div>
                                <div className="text-[10px] text-slate-500 whitespace-normal break-words md:truncate md:whitespace-nowrap">
                                    {t('navbar.eduLinksDesc')}
                                </div>
                            </div>
                        </div>

                        <div className="flex items-start sm:items-center gap-2 sm:gap-3">
                            <span className="inline-flex h-8 w-8 sm:h-9 sm:w-9 items-center justify-center rounded-full bg-white border-[2px] border-[#006C35] text-[#006C35] shrink-0">
                                <Link2 size={18} />
                            </span>
                            <div className="min-w-0 text-right leading-snug">
                                <div className="text-[12px] font-bold text-[#006C35] whitespace-normal break-words md:truncate md:whitespace-nowrap">
                                    {t('navbar.secureLinksTitle')}
                                </div>
                                <div className="text-[10px] text-slate-500 whitespace-normal break-words md:truncate md:whitespace-nowrap">
                                    {t('navbar.secureLinksDesc')}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-span-2 my-2">
                        <div className="bg-white flex items-center p-2 rounded-md">
                            <img src={dgi} alt="dgi" className="w-4 ml-2" />
                            <span className="text-[11px] text-[#6c737f]">
                                مسجل لدى هيئة الحكومة الرقمية برقم:
                                <a href="" target="_blank" className="text-[#006c35]">
                                    20240423975
                                </a>
                            </span>
                            <svg className="text-[#006c35] mr-2" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-external-link w-3 h-3"><path d="M15 3h6v6"></path><path d="M10 14 21 3"></path><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path></svg>
                        </div>

                    </div> */}
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-[72px]">

                    {/* Right side: Logo & Branding */}
                    <Link to="/" className="flex items-center gap-4 hover:opacity-90 transition-opacity">
                        <div className="w-36 py-2">
                            <img
                                src={logo}
                                alt={t('navbar.logoAlt')}
                                className="w-full object-contain"
                            />
                            <span className="text-[10px] font-semibold text-center text-nowrap block text-gray-800">{t('navbar.deanshipName')}</span>
                        </div>
                        {/* Divider for government platforms style */}
                        <div className="hidden lg:block h-10 w-[1px] bg-gray-200 mx-2"></div>
                        <div className="hidden lg:flex flex-col text-right">
                            {/* <span className="text-[10px] text-gray-500 font-medium leading-none uppercase tracking-wider">رصين - النظام المالي والإداري</span> */}
                            <span className="text-sm font-bold text-gray-800">{t('navbar.platformName')}</span>
                        </div>
                    </Link>

                    {/* Left side: Navigation links (Desktop) */}
                    <div className="hidden md:flex items-center gap-10">
                        {links.map((link, index) => (
                            <Link
                                key={index}
                                to={link.to}
                                className="relative text-gray-700 hover:text-[#006C35] transition-all duration-300 font-semibold text-sm group"
                            >
                                {link.name}
                                <span className="absolute -bottom-1 right-0 w-0 h-0.5 bg-[#006C35] transition-all duration-300 group-hover:w-full"></span>
                            </Link>
                        ))}
                        <button 
                            onClick={toggleLanguage}
                            className="flex items-center gap-1 text-gray-700 hover:text-[#006C35] transition-colors font-semibold text-sm"
                        >
                            <Globe size={18} />
                            <span>{i18n.language === 'ar' ? 'English' : 'العربية'}</span>
                        </button>
                    </div>

                    {/* Mobile Menu Button */}
                    <div className="md:hidden flex items-center gap-4">
                        <button 
                            onClick={toggleLanguage}
                            className="text-gray-600 hover:text-[#006C35] transition-colors"
                        >
                            <Globe size={20} />
                        </button>
                        <button
                            onClick={() => setIsOpen(!isOpen)}
                            className="p-2 rounded-lg text-gray-600 hover:bg-gray-50 focus:outline-none transition-colors"
                            aria-label={t('navbar.menu')}
                        >
                            {isOpen ? <X size={24} color={colors.primaryGreen} /> : <Menu size={24} />}
                        </button>
                    </div>
                </div>
            </div>

            {/* Mobile Menu Dropdown */}
            <div
                className={`md:hidden bg-white overflow-hidden transition-all duration-300 ease-in-out border-t border-gray-50 ${isOpen ? "max-h-[500px] opacity-100 pb-6" : "max-h-0 opacity-0"
                    }`}
            >
                <div className="px-6 flex flex-col space-y-2 mt-4">
                    {links.map((link, index) => (
                        <Link
                            key={index}
                            to={link.to}
                            onClick={() => setIsOpen(false)}
                            className="py-3 px-4 rounded-xl text-gray-700 hover:bg-green-50 hover:text-[#006C35] transition-all font-medium text-right"
                        >
                            {link.name}
                        </Link>
                    ))}
                </div>
            </div>

        </nav>
    );
}
